import { Box } from '@material-ui/core';

const LoggedInContent = ({ children }) => <Box margin={2}>{children}</Box>;

export default LoggedInContent;
